import InputFilter from './InputFilter'
export default InputFilter
